/**
 * 엔티티 루트용 Konva.Group 서브클래스.
 *
 * Konva 9의 Container._clearSelfAndDescendantCache는 캐시된 컨테이너에서 하위 노드 무효화를 생략한다.
 * 캐시된 엔티티에 listening/visible을 껐다 켜면 하위 그룹(풍선 그룹·래퍼)의 isListening/isVisible 캐시가
 * false로 남아, 풍선 Rect는 hit되지만 부모가 non-listening으로 판정돼 이벤트가 엔티티까지 버블링되지 않는다
 * (모바일에서 팬 중 listening(false) → 복원 후 번호풍선 터치 선택 불가).
 *
 * 엔티티(BaseEntityProperties)는 `renderer.createGroup({ entityRoot: true })`로 이 그룹을 루트 노드로 받는다
 * (상속 시절 BaseEntityProperties에 있던 같은 오버라이드를 이어받음).
 */
import Konva from 'konva'
import type { GroupConfig as KonvaGroupConfig } from 'konva/lib/Group'

export class KonvaEntityGroup extends Konva.Group {
  constructor(config?: KonvaGroupConfig) {
    super(config)
  }

  _clearSelfAndDescendantCache(attr?: string): void {
    super._clearSelfAndDescendantCache(attr)
    if (!this.isCached() || (attr !== 'listening' && attr !== 'visible')) return
    this.getChildren().forEach((child: Konva.Node) => child._clearSelfAndDescendantCache(attr))
  }
}
